import * as recipes from "@client/features/recipes";
import * as search from "@client/features/search";

import * as router from "@client/router";

import {submitForm} from "@client/site/forms";
import {server} from "@reactivated";

export const CreateRecipeFromMeal = router.CreateRecipeFromMeal.withHooks((props) => {
    return recipes.useRecipeForm({
        initial: {
            ...(props.resolved.update_meal.recreate_recipe ?? {}),
            container_unit: props.resolved.update_meal.recreate_recipe
                ?.container_unit as "g",
        },
    });
})
    .withIndex((props) => props.layout.component)
    .withActions((props) => [
        {
            icon: "save",
            title: "Save",
            onClick: async () => {
                const result = await submitForm(
                    server.journal.nutrition.create_recipe_from_meal,
                    {
                        ...props.form.values,
                        meal_id: props.resolved.update_meal.uuid,
                    },
                    props.form,
                );
                if (result.type === "success") {
                    void props.dispatch(search.loadSearch({reset: true}));
                    router.replace("journal.journal", {
                        key: props.resolved.update_meal.key,
                    });
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Convert Meal to Recipe",
        back: "Meal",
    }));
